import React from 'react'
import { Chip, Tooltip, keyframes } from '@mui/material'
import ScienceIcon from '@mui/icons-material/Science'

const pulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(237, 108, 2, 0.45); }
  70%  { box-shadow: 0 0 0 6px rgba(237, 108, 2, 0); }
  100% { box-shadow: 0 0 0 0 rgba(237, 108, 2, 0); }
`

/**
 * Marcação visual de versão BETA.
 * Controlada pela variável de ambiente VITE_APP_BETA.
 * Retorna null quando VITE_APP_BETA !== 'true' — sem custo de renderização.
 */
export default function BetaBadge() {
  if (import.meta.env.VITE_APP_BETA !== 'true') {
    return null
  }

  return (
    <Tooltip
      title="Versão beta — funcionalidades em desenvolvimento, sujeitas a mudanças"
      arrow
      placement="bottom"
    >
      <Chip
        icon={<ScienceIcon sx={{ fontSize: '0.85rem !important', ml: '6px !important' }} />}
        label="BETA"
        size="small"
        sx={{
          height: 22,
          fontSize: '0.68rem',
          fontWeight: 700,
          letterSpacing: '0.06em',
          bgcolor: '#fff3e0',
          color: '#e65100',
          border: '1px solid #ffcc80',
          borderRadius: '6px',
          cursor: 'default',
          userSelect: 'none',
          flexShrink: 0,
          animation: `${pulse} 2.5s ease-in-out infinite`,
          '& .MuiChip-icon': {
            color: '#e65100',
          },
          '& .MuiChip-label': {
            px: '6px',
          },
        }}
      />
    </Tooltip>
  )
}
